import { useCallback, useEffect, useState } from 'react';
import type { CatalogPart } from '@ddp/shared';

import { apiFetch } from '../../api/client.js';

/**
 * Catalogue de pièces (ADR-0030) : le référentiel **global organisé**, non cloisonné. Lecture ouverte
 * à tout membre ; la curation d'écriture (dont l'illustration, ADR-0032) est réservée au `SUPERADMIN`.
 * Chargé une fois, filtré côté client — le catalogue est modeste et stable. `refresh` relit après une
 * curation d'image.
 */
export function useCatalog() {
  const [parts, setParts] = useState<CatalogPart[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      setParts(await apiFetch<CatalogPart[]>('/catalog'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let active = true;
    apiFetch<CatalogPart[]>('/catalog')
      .then((p) => {
        if (active) {
          setParts(p);
          setLoading(false);
        }
      })
      .catch(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return { parts, loading, refresh };
}
